import React, { useState } from 'react';
import { formatCLP, formatFecha, diasHasta } from '../lib/format';

const ETIQUETA_TIPO = { gasto_fijo: 'Gasto fijo', deuda: 'Cuota', compromiso: 'Compromiso', envio: 'Envíos' };

function cuando(fecha) {
  if (!fecha) return { texto: 'Sin fecha', clase: '' };
  const d = diasHasta(fecha);
  if (d < 0) return { texto: `Vencido hace ${-d} día${d === -1 ? '' : 's'}`, clase: 'text-danger' };
  if (d === 0) return { texto: 'Vence hoy', clase: 'text-danger' };
  if (d === 1) return { texto: 'Vence mañana', clase: 'text-warning' };
  return { texto: `Vence el ${formatFecha(fecha).slice(0, 5)} · en ${d} días`, clase: d <= 7 ? 'text-warning' : '' };
}

// Lista de lo que viene: cuánto sale en los próximos días y cuánto te queda después de pagarlo.
function ProximosPagos({ proximos, disponible, porCobrar = 0 }) {
  const [verTodo, setVerTodo] = useState(false);
  const { items, total, yaApartado, porApartar } = proximos;
  const quedaria = disponible - porApartar;
  const visibles = verTodo ? items : items.slice(0, 8);

  return (
    <div className="card" style={{ display: 'block', padding: 16, marginBottom: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 8, flexWrap: 'wrap' }}>
        <h3 style={{ margin: 0 }}>📅 Próximos pagos · 30 días</h3>
        <strong>{formatCLP(total)}</strong>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: 8, margin: '12px 0' }}>
        <div style={{ background: 'var(--bg)', borderRadius: 8, padding: 10 }}>
          <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>Ya apartado (compromisos)</div>
          <strong>{formatCLP(yaApartado)}</strong>
        </div>
        <div style={{ background: 'var(--bg)', borderRadius: 8, padding: 10 }}>
          <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>Falta por apartar</div>
          <strong className={porApartar > 0 ? 'text-warning' : ''}>{formatCLP(porApartar)}</strong>
        </div>
        <div style={{ background: quedaria < 0 ? 'var(--danger-bg)' : 'var(--success-bg)', borderRadius: 8, padding: 10 }}>
          <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>Te quedaría libre después de pagar todo</div>
          <strong className={quedaria < 0 ? 'text-danger' : 'text-success'}>{formatCLP(quedaria)}</strong>
        </div>
      </div>
      {porCobrar > 0 && (
        <p className="field-hint" style={{ marginTop: 0 }}>
          Además te deben {formatCLP(porCobrar)} (Me Deben); no está sumado aquí hasta que te paguen.
        </p>
      )}

      {items.length === 0 ? (
        <p className="empty-text">No hay pagos pendientes en los próximos 30 días. 🎉</p>
      ) : (
        <>
          {visibles.map(i => {
            const c = cuando(i.fecha);
            return (
              <div key={i.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 0', borderTop: '1px solid var(--border)' }}>
                <span style={{ fontSize: '1.2rem' }}>{i.icono}</span>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{i.nombre}</div>
                  <div style={{ fontSize: '0.75rem' }}>
                    <span className={c.clase}>{c.texto}</span>
                    <span style={{ color: 'var(--text-muted)' }}>
                      {' · '}{ETIQUETA_TIPO[i.tipo]}{i.detalle ? ` · ${i.detalle}` : ''}
                    </span>
                  </div>
                </div>
                <strong style={{ whiteSpace: 'nowrap', opacity: i.apartado ? 0.6 : 1 }}>{formatCLP(i.monto)}</strong>
              </div>
            );
          })}
          {items.length > 8 && (
            <button className="btn-secondary" style={{ marginTop: 8 }} onClick={() => setVerTodo(!verTodo)}>
              {verTodo ? 'Ver menos' : `Ver los ${items.length}`}
            </button>
          )}
        </>
      )}
      <p className="field-hint" style={{ marginBottom: 0 }}>
        Los gastos fijos sin "día de vencimiento" salen como "Sin fecha"; agrégalo en Gastos Fijos con ✎. Los montos variables usan el último pago.
      </p>
    </div>
  );
}

export default ProximosPagos;
